import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "@/lib/analytics";

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
